// src/components/Partners.js
import React from 'react';
import './Partners.css';

// Dummy images (replace with actual image imports)
import Toyota from '../../../imgs/Toyota.webp';
import DJI from '../../../imgs/DJI.webp';
import Tupperware from '../../../imgs/Tupperware.webp';
import Groupep from '../../../imgs/Groupep.webp';
import Pepsi from '../../../imgs/Pepsi.webp';

const Partners = () => {
    const clients = [
        { id: 1, img: Toyota },
        { id: 2, img: DJI },
        { id: 3, img: Tupperware },
        { id: 4, img: Groupep },
        { id: 5, img: Pepsi },
    ];
    return (
        <div className="partners-container">
            <h2 className="partners-title">Our Star Clients and Partners</h2>
            <div className="partners-grid">
                {clients.map(({ id, name, img }) => (
                    <div key={id} className="partner-card">
                        <img src={img} alt={name} className="partner-img" />
                        <p className="partner-name">{name}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Partners;
